import Initialiser from 'initialiser';
import constants from 'utils/constants';
import { cloneDeep } from 'utils/immutable';

// ACTION TYPES
const HOVER_SHARE = 'HOVER_SHARE';

// SYNC ACTION CREATORS
export function hoverShare(ipis, entityType, shareType = constants.ShareType.NONE) {
    return { type: HOVER_SHARE, hover: { ipis, entityType, shareType } };
}

// REDUCERS
export default function reducer(state = Initialiser.initialState.hover, action) {
    switch (action.type) {
        case HOVER_SHARE: {
            if (action.hover.ipis.map((ipi) => ipi.ipi).indexOf(constants.HoverIPIs.NONE) > -1) {
                return cloneDeep({
                    ipis: action.hover.ipis,
                    entityType: action.hover.entityType,
                    shareType: action.hover.shareType,
                });
            }
            let ipis = state.ipis.slice();
            if (ipis.map((ipi) => ipi.ipi).indexOf(constants.HoverIPIs.NONE) > -1) {
                ipis.splice(ipis.map((ipi) => ipi.ipi).indexOf(constants.HoverIPIs.NONE), 1);
            }
            ipis = ipis.concat(action.hover.ipis);
            return cloneDeep({
                ipis,
                entityType: action.hover.entityType,
                shareType: action.hover.shareType,
            });
        }
        default: {
            return state;
        }
    }
}
